/** Share API functions. */

import { apiGet, apiPost, apiDelete } from '@/api/client';
import type { ShareLinkResponse } from '@/api/types';

export function createShareLink(
  mapId: string,
  permission: 'view' | 'edit',
  expiresInDays?: number,
): Promise<ShareLinkResponse> {
  return apiPost<ShareLinkResponse>(`/maps/${mapId}/share`, {
    permission,
    ...(expiresInDays !== undefined ? { expiresInDays } : {}),
  });
}

export interface ResolvedShareLink {
  mapId: string;
  permission: string;
  downloadUrl: string;
}

export function resolveShareLink(token: string): Promise<ResolvedShareLink> {
  return apiGet<ResolvedShareLink>(`/shared/${token}`);
}

export interface ShareLinkSummary {
  token: string;
  permission: 'view' | 'edit';
  expiry: string;
  createdAt: string;
}

export interface ListShareLinksResponse {
  links: ShareLinkSummary[];
}

export function listShareLinks(mapId: string): Promise<ListShareLinksResponse> {
  return apiGet<ListShareLinksResponse>(`/maps/${mapId}/shares`);
}

export function revokeShareLink(mapId: string, token: string): Promise<void> {
  return apiDelete(`/maps/${mapId}/shares/${token}`);
}
